import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=d975730e&"
import script from "./AddCard.vue?vue&type=script&lang=js&"
export * from "./AddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports